import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function AlphaBanner() {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <>
      <div className="bg-primary/10 border-b border-primary/20 py-1 px-4">
        <div className="container flex items-center justify-center">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  className="gap-1 h-6"
                  onClick={() => setChatOpen(true)}
                >
                  <Info className="h-3.5 w-3.5" />
                  <span className="text-xs font-normal">Private Alpha</span>
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm">NewLoop is currently in private alpha. Click to learn more and provide feedback.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>

      {/* Alpha Info Dialog */}
      <Dialog open={chatOpen} onOpenChange={setChatOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Welcome to NewLoop Private Alpha</DialogTitle>
            <DialogDescription>
              We're excited to have you try NewLoop during our private alpha phase. Your feedback helps us improve the platform.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <p>Current features in testing:</p>
            <ul className="list-disc pl-4 space-y-2">
              <li>AI-powered resume parsing and analysis</li>
              <li>Career path planning and recommendations</li>
              <li>Smart job matching</li>
              <li>Interview scheduling</li>
            </ul>
            <p className="text-sm text-muted-foreground">
              Have feedback or found a bug? Email us at feedback@newloop.ai
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}